import { apiFetch } from "./apiFetch";

export function fetchCommitments(goalId, includeArchived = false) {
  const archived = includeArchived ? "&include_archived=true" : "";
  return apiFetch(`/commitments/?goal=${goalId}${archived}`);
}

export function fetchAllCommitments() {
  return apiFetch("/commitments/");
}

export function createCommitment(payload) {
  return apiFetch("/commitments/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateCommitment(commitmentId, payload) {
  return apiFetch(`/commitments/${commitmentId}/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function replaceCommitment(commitmentId, payload) {
  return apiFetch(`/commitments/${commitmentId}/replace/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function deleteCommitment(commitmentId) {
  return apiFetch(`/commitments/${commitmentId}/`, {
    method: "DELETE",
  });
}
